export default {
  login: {
    'Welcome_to_TC_system': "欢迎登录TC系统",
    "Login_account": "登录账号",
    "Please_enter_your_login_account": "请输入登录账号",
    "Login_password": "登录密码",
    "Please_enter_your_login_password": "请输入登录密码",
    "Remember_the_account_password": "记住账号密码",
    "Enterprise_wechat_login": "企业微信登录",
    "Log_in": "登录",
    "logining": "登录中",
    "Login_success": "登录成功",
    "Login_failure": "登录失败",
    "exit": "退出",
    "exiting": "退出中",
    "Exit_successfully": "退出成功",
    "Exit_failure": "退出失败",
    "Welcome_to_login_TC_system": "欢迎登录TC系统",
    "account": "登录账号",
    "Password": "登录密码",
    "Please_enter_login_account": "请输入登录账号",
    "Please_enter_login_password": "请输入登录密码",
    "Log_in_Wecom": "企业微信登录",
    "It_is_on_the_access_road": "登录中",
    "Access_error": "登录失败",
  },
  menu: {
    "WarehouseData": "仓库数据",
    "operate_time": "货件操作时间",
    "View_details": "查看详情",
    "Warehousing_management": "入库管理",
    "Out_warehouse_management": "出库管理",
    "Order_management": "订单管理",
    "Pallet_management": "容器管理",
    "Abnormal_data": "异常数据",
    "Warehousing_anomaly": "入库异常",
    "Outgoing_exception": "出库异常",
    "Operation_exception": "操作异常",
    "Vehicle_management": "车辆管理",
    "Order_list": "订单目录",
    "warehouse_data": "仓库数据",
    "goods_age_statistics": "货物库龄统计",
    "data_statistics": "数据统计",
    "classification_data": "分区数据",
    "classification_details": "分区详情",
    "pela_details": "托盘详情",
    "cargo_entry_management": "入库管理",
    "cargo_entry_details": "入库详情",
    "Shipment_details": "运单详情",
    "load_output_administration": "出库管理",
    "load_output_details": "出库详情",
    "order_administration": "订单管理",
    "order_details": "订单详情",
    "abnormal_load_input_situation": "入库异常",
    "abnormal_situation_details": "异常详情",
    "load_output_abnormal_situation": "出库异常",
    "abnormal_driving_situation": "操作异常",
    "container_administration": "容器管理",
    "container_details": "容器详情",
    "location_management": "库位管理",
    "classification_management": "分区管理",
    "platform_management": "卡板管理",
    "car_management": "车辆管理",
    "Mercado_Libre_Reservation": "美客多预约",
    "Reservation_status": "预约情况",
    "Check_the_shipment_number": "货件号查询",
    "Basic_setup": "基础设置",
    "Warehouse_details": "仓库详情",
    "Enterprise_architecture_management": "企业架构管理",
    "System_setting": "系统设置",
    "Department_setting": "部门设置",
    "Employee_account_management": "员工账号管理",
    "Role_rights_management": "角色权限管理",
    "Role_setting": "角色设置",
    "Authority_management": "权限管理",
    "Work_order_management": "工单管理",
    "Add_new_work_order": "新建工单",
    "Work_order_details": "工单详情",
    "Customer_service_Settings": "客服设置",
    "Work_order_type": "工单类型",
    "Problem_type": "问题类型",
    "Drafts": "草稿箱",
    "check": "查看",
    "add": "新建",
    "intercept": "出仓拦截",
    "updateFiles": "更新附件",
    "delete": "删除",
    "cancel": "取消送仓",
    "edit": "编辑",
    "download": "下载",
    "storage_management": "库位管理",
    "No_owner_claimed_the_goods": "无主认领货物",
    "return_claim": "退货认领",
    "loadingLot": "装车批次",
    "lotDetail": "批次详情",
    "return_goods": "退货/美墨",
    "returnGoods": "退货/美墨",
    "warehouse": "入仓",
    "outwarehouse": "出仓",
    "refuseOutwarehouse": "拒收回仓",
    "transfer": "转移",
    "inventory": "盘点",
    "pickGoods": "拣货",
    "listGoods": '货物处理',
    "outerSheet": "外箱标",
    "productSheet": "产品标",
    "findGoods": "查货",
    "claimGoods": "货物认领",
    "truckLoading": "装车",
    "picsUpload": "图片上传",
    "changeLabel": "贴换标",
    "checkZone": "库位查看",
    "Update": "更新",
    "pda": "pda",
    "areaScan": "区域扫码",
    "goods_ageing": "货物库龄",
    "zoneInventory": "库位清点",
    "workSheet": "工单处理",
    "storage_list": "库存列表",
    "storage_of_goods": "货物仓储",
    "cargo_storage_details": "货物仓储详情",
    "cargo_delivery_information": "货物送仓信息",
    "abnormal_shipments": "库存异常货件",
    "first_route_order": "头程订单",
    "transfer_warehouse_order": "转仓订单",
    "order_detail": "订单详情",
    "transferWarehouseProcess": "转仓处理",
    "transferToWarehouse": "转仓入仓",
    "warehouseOrder": "库内订单",
    "drop_shipping_outwarehouse": "一件代发出库",
    "drop_shipping_outwarehouse_detail": "一件代发出库详情",
    "picking_task": "拣货任务",
    "picking_order": "拣货订单",
    "picking_outwarehouse": "拣货出库",
    "task_detail": "任务详情",
    "warehousing_manage": "入库管理",
    "container_manage": "一件代发容器管理",
    "location_manage": "一件代发库位管理",
    "distribution_manage": "配货管理",
    "shelves_manage": "上下架管理",
    "pull_on_shelves_list": "上架列表",
    "pull_off_shelves_list": "下架列表",
    "warehouse_manage": "仓库管理",
    "goods_stock": "货物库存",
    "sku_stock": "SKU总库存",
    "sku_batch_stock": "SKU批次库存",
    "sku_shelf_stock": "SKU货架库存",
    "inventory_adjustment": "库存调整",
    "container_detail": "容器详情",
    "product_information": "商品信息",
    "order_manage": "订单管理",
    "all_order": "全部订单",
    "shein_order": "SHEIN订单",
    "warehouse_detail": "仓库详情",
    "subarea_detail": "分区详情",
    "location_detail": "库位详情",
    "goods_stock_detail": "货物详情",
    "general_situation": "概况",
    "batchOutWarehouse": "批量出库",
    "UpdateTheOutboundTime": "更新出库时间",
    "DestroyGoods": "请求销毁货物",
    "system_setting": "系统设置",
    "courier_freight_manage": "快递商运费管理",
    "setupOutaccount": "设置出账",
    "shipment": "货件号信息",
    "changeShipment": "换标货件号",
    "batchDistributionWorkSheet": "批量分配工单",
    "warehouse_order": "仓库订单",
    "new_order": "新建订单",
    "good_change_label": "货物换标",
    "good_change_label_detail": "货物换标详情",
    "account_information": "账号信息",
    "login": "登录",
    "logout": "登出",
    "userinfo": "用户信息",
    "operating_function": "操作功能",
    "Home_Page_Functions": "首页功能",
    "goods_sku_stock": "货物sku库存",
    "goods_in_warehouse": "货物入库",
    "out_of_stock_order_change_label": "出库单换标",
    "out_of_stock_order_change_label_details": "出库单换标详情",
    "rfid": "RFID",
    "search_goods_task": "找货任务",
    "search_goods_task_details": "找货任务详情",
    "related_sub_order": "关联子单",
    "inbound_inspection_task": "入库检测任务",
    "inbound_inspection_task_details": "入库检测任务详情",
    "findGoodsOutwarehouse": "出仓查货",
    "overseas_qr_code_statistics": "海外扫码统计",
    "employee_name": "员工名称",
    "Time_selection": "时间选择",
    "Scan_code_statistics": "扫码统计",
    "Statistics_of_scanning_and_entering_warehouse": "扫码入仓统计",
    "Scan-to-issue_statistics": "扫码出库统计",
    "Statistics_of_scanning_and_listing": "扫码上架统计",
    "Statistics_of_products_removed_from_shelves_after_scanning": "扫码下架统计",
    "Scan_and_count_statistics": "扫码盘点统计",
    "Scan_outer_box_label_statistics": "扫外箱标统计",
    "Scan_product_labels_for_statistics": "扫产品标统计",
    "warehouse_loading": "仓库装车",
    "Details_of_warehouse_delivery": "送仓详情",
    "Warehouse_delivery": "送仓仓库",
    "Number_of_items_scanned_and_released_from_storage": "已扫码出仓数",
    "Number_of_items_to_be_issued_from_storage": "应出仓数",
    "Number_of_vehicles_that_should_be_loaded": "应装车数",
    "Number_of_vehicles_loaded": "已装车数",
    "Number_of_units_not_loaded": "未装车数",
    "Please_select_the_delivery_date_first": "请先选择送仓日期",
    "Scanned_and_loaded": "已扫码装车",
    "Scanned_and_loaded_onto_the_vehicle": "已扫码装车",
    "Loading_without_scanning_the_code": "未扫码装车",
    "truckCarScan": "装车扫码",
    "outbound_order_extraction_label": "出库单提取标签",
    "Tag_separation": "标签分割",
    "abnormal_update_prompt": "异常更新提示",
    "Are_you_sure_you_want_to_split_the_labels": "确定要对标签进行分割吗？",
    "Are_you_sure_you_want_to_clear_all_uploaded_files": "确定要清空上传的所有文件吗？",
    "Please_enter_the_file_name": "请输入文件名",
    "Please_upload_and_complete_the_segmentation_first": "请先上传并完成分割",
    "Please_select_the_warehouse_delivery_date": "请选择送仓日期",
    "Cleared": "已清空",
    "No_files_available_for_upload": "没有可上传的文件",
    "In_the_process_of_packaging_and_uploading": "正在打包上传中",
    "Split_successfully": "分割成功",
    "ocr_extract_excel": "OCR提取excel",
    "truck_loading_bonded_warehouse": "保税仓装车",
    "truck_loading_bonded_warehouse_details": "保税仓装车详情",
    "warehousing_summary": "入库汇总",
    "warehousing_summary_details": "入库汇总详情",
    "Amazon_appointment_delivery_registration": "亚马逊预约送仓登记",
    "Amazon_delivery_shipping_information": "亚马逊送仓货件信息",
    "Top_function": "顶部功能",
    "Large_screen_data_dashboard": "大屏数据看板",
    "show_board": "大屏看板功能",
    "setUnknown": "更改库存为未知",
  },
  selectPart: {
    "Operation_center": "操作中心",
    "order_center": "订单中心",
    "Enterprise_center": "企业中心",
    "Service_center": '客服中心',
    "pda": "pda",
    "PDA_dropShipping": "PDA一件代发",
    "Inventory_center": "库存中心",
    "distribution_center": "配货中心",
    "other_mode": "其它模块",
  },
  warehouseData: {
    "Goods_to_be_listed": "待上架货物",
    "Container_code_to_be_listed": "待上架容器码",
    "Current_pieces": "当前件数/件",
    "Current_pieces_of_order/ticket": "当前订单数/票",
    "Total_weight": "总重量",
    "Total_weight/volume": "总容量、体积",
    "Pending_arrival_orders_at_the_warehouse": "待入仓订单",
    "Orders_pending_handling": "待操作订单",
    "abnormal_orders": "异常订单",
    "orders_that_have_been_held_for_a_long_time": "存放过久订单",
    "Total_pieces": "总件数/件",
    "Total_volume": "总体积",
    "Total_order/ticket": "总订单/票",
    "Day": "日",
    "Month": "月",
    "Year": "年",
    "cargo_intake_today/piece": "今日入库/件",
    "Morning": "上午",
    "Afternoon": "下午",
    "cargo_departure_today/piece": "今日出库/件",
    "Handling_today/piece": "今日操作/件",
    "Classification_of_warehouse_area": "仓库分区",
    "Import_data": "数据导入",
    "reservation_space_is_less_than": "存储空间小于",
    "cargo_entry_worker": "入库操作员",
    "Time_of_warehousing": "入库时间",
    "Warehouse": "所在仓库",
    "classification_area": "分区",
    "pallet_number": "卡板号",
    "deposit_time": "存放时长",
    "secondary_shipment_number": "子运单号",
    "secondary_shipping/secondary_outer_carton_label": "子货件号/子唛头",
    "Pieces": "件数/件",
    "Weight": "重量",
    "Number_of_shipment": "运单号",
    "Number_of_entering_warehouse": "入库单号",
    "Number_of_products/tag": "货件号/唛头",
    "choose_classification_area": "分区选择",
    "filter": "筛选",
    "Reset": "重置",
    "Client_name": "客户名称",
    "Salesman": "业务员",
    "deposit_time/day": "存放时长/天",
    "handling": "操作",
    "Check": "查看",
    "Please_enter_content": "请输入内容",
    "No_region_storage_information_was_entered": "未录入区域存储信息",
    "Storage_space_less_than": "存储空间小于",
    "Search_results": "搜索结果",
    "Total": "总件数",
    "Old_shipment_number": "旧货件号",
    "Old_sub-shipment_number/shipping_mark": "旧子货件号/唛头",
    "change_order_number": "改单号",
    "region_name": "区域名",
    "status": "状态",
    "Update_time": "更新时间",
    "volume": "体积",
    "Data_export": "数据导出",
    "Already_listed": "已上架",
    "Taken_down": "已下架",
    "De_listing": "下架",
    "Total_number_of_locations": "总库位数",
    "The_number_of_used_storage_locations": "已使用库位数",
    "Number_of_empty_storage_locations": "空库位数",
  },
  warehousing: {
    "delivery_number": "运单号",
    "cargo_entry_number": "入库单号",
    "shipping/outer_box_label": "货件号/唛头",
    "state": "状态",
    "Container_pick_up_date": "提柜日期",
    "Container_number": "柜号",
    "SO_number": "SO号",
    "cargo_entry_time": "入库时间",
    "import_data": "数据导入",
    "export_data": "数据导出",
    "filter": "筛选",
    "reboot": "重置",
    "pick_up_order_number/container_number": "提单号/柜号",
    "type_of_transport": "运输类型",
    "related_shipping_quantity/pcs": "关联运单数/条",
    "total_pieces/piece": "总件数/件",
    "total_volume/cubic_meters": "总体积/CBM",
    "total_weight/kg": "总重量/KG",
    "warehouse_receipt_amount/piece": "已入仓件数/件",
    "review": "查看",
    "secondary_shipment_number": "子运单号",
    "secondary_shipping/secondary_outer_carton_label": "子货件号/子唛头",
    "product_parts/parts": "产品数量/件",
    "volume/cubic_meters": "体积/CBM",
    "weight/kg": "重量/KG",
    "have_been_entered": "已入库",
    "total_pieces": "总件数",
    "total_weight": "总重量",
    "total_volume": "总体积",
    "cargo_entry_parts": "已入库件数",
    "pieces_without_charge_entry": "未入库件数",
    "driving": "操作",
    "print_income_sheet": "打印入库单",
    "export_income_sheet": "导出入库单",
    "warehousing": "待入库",
    "Failed_to_get_warehousing_list": "获取入仓列表失败",
    "Transport_type": "运输类型",
    "Failed_to_get_warehousing_details": "获取入仓详情失败",
    "Failed_to_get_waybill_details": "获取运单详情失败",
    "shipping": "货件号",
    "secondary_shipping": "子货件号",
    "location_code/container_code": "库位码/容器码",
    "all": "全部",
    "warehoused": "已出库",
    "exporting": "导出中",
    "Export_successfully": "导出成功",
    "printing": "打印中",
    "Print_successfully": "打印成功",
    "Print_unsuccessfully": "打印失败",
    "Company_logo": "公司标识",
    "Export_unsuccessfully": "导出失败",
    "RFID_quantity": "RFID件数",
    "New_RFID_inbound_inspection_has_been_added": "新增RFID入库检测",
    "The_new_RFID_inbound_detection_has_been_successfully_added": "新增RFID入库检测成功",
    "The_new_RFID_inbound_inspection_failed": "新增RFID入库检测失败",
    "The_number_of_items_on_the_inventory_sheet_does_not_match_the_number_of_RFID_tags_Are_you_sure_you_want_to_proceed_with_creation": "入库单件数与RFID数量不一致，是否确认创建？",
    "The_number_of_leading_stars_is_odd": "领星运单数",
    "The_number_of_stars_received": "领星件数",
  },
  outwarehouse: {
    "delivery_number": "运单号",
    "load_output_number": "出库单号",
    "shipping/outer_box_label": "货件号/唛头",
    "state": "状态",
    "creation_date": "创建日期",
    "cargo_departure_time": "出库时间",
    "related_shipping_quantity/pcs": "关联运单数/条",
    "scan_quantity/pieces": "已扫码件数/件",
    "person_responsible_for_shipping": "送仓负责人",
    "shipping_car_number": "送仓车牌号",
    "secondary_shipment_number": "子运单号",
    "secondary_shipping/secondary_outer_carton_label": "子货件号/子唛头",
    "successful_scan_parts": "已扫码件数",
    "parts_without_scanning": "未扫码件数",
    "download_authorization": "下载授权书",
    "print_output_sheet": "打印出库单",
    "overload_attachment_information": "重载附件信息",
    "export_output_sheet": "导出出库单",
    "Create_delivery_list": "新建出库单",
    "title": "标题",
    "Total": "总件数",
    "related_shipping_quantity": "关联运单数",
    "successful_number": "已扫码件数",
    "reject_number": "拒收件数",
    "intercept_number": "拦截件数",
    "creator": "创建人",
    "address": "地址",
    "Create_time": "创建时间",
    "Delivery_time": "送仓时间",
    "remark": "备注",
    "driving": "操作",
    "view": "查看",
    "delete": "删除",
    "Are_you_sure_to_delete": "确定删除？",
    "confirm": "确定",
    "cancel": "取消",
    "waiting_for_out_warehouse": "待出库",
    "warehousing": "出库中",
    "warehoused": "已出库",
    "out_warehouse_abnormally": "出库异常",
    "deleting": "删除中",
    "Successfully_delete": "删除成功",
    "Delete_unsuccessfully": "删除失败",
    "Failed_to_get_out_warehouse_list": "获取出库列表失败",
    "Attached_file": "附带文件",
    "Only_support": "仅支持",
    "format": "格式",
    "upload": "上传",
    "save": "保存",
    "saving": "保存中",
    "Save_successfully": "保存成功",
    "Save_unsuccessfully": "保存失败",
    "Intercepted_number_of_out_warehouse": "出仓拦截件数",
    "Scan_list": "扫码列表",
    "batch_out_warehouse": "批量出库",
    "destroy_goods": "请求销毁货物",
    "out_warehouse_intercept": "出仓拦截",
    "Are_you_sure_to_out_warehouse?": "确定出库？",
    "File_list": "文件列表",
    "batch_download": "批量下载",
    "take_a_photo_and_send_back": "拍照回传",
    "Download": "下载",
    "close": "关闭",
    "Reject_list": "拒收列表",
    "reject_reason": "拒收原因",
    "filter": "筛选",
    "reset": "重置",
    "edit": "编辑",
    "Download_attachment": "下载附件",
    "Update_attachment": "更新附件",
    "Export_the_reject_list": "导出拒收列表",
    "All": "全部",
    "Scanned": "已扫描",
    "To_be_scanned": "待扫描",
    "rejection": "拒收",
    "Failed_to_get_out_warehouse_details": "获取出库详情失败",
    "Please_check_first": "请先勾选",
    "Batch_delivery_successfully": "批量出库成功",
    "Batch_out_warehouse_unsuccessfully": "批量出库失败",
    "Failed_to_get_fileList": "获取文件列表失败",
    "File_is_empty": "文件为空",
    "Download_successfully": "下载成功",
    "Download_unsuccessfully": "下载失败",
    "Failed_to_get_scan_list": "获取扫码列表失败",
    "The_attached_file_is_empty": "附件文件为空",
    "exporting": "导出中",
    "Export_successfully": "导出成功",
    "Export_unsuccessfully": "导出失败",
    "Print_unsuccessfully": "打印失败",
    "printing": "打印中",
    "Print_successfully": "打印成功",
    "intercept_reason": "拦截原因",
    "intercepting": "出仓拦截中",
    "Intercept_successfully": "出仓拦截成功",
    "Intercept_unsuccessfully": "出仓拦截失败",
    "Edit_reject_reason": "编辑拒收原因",
    "editing": "编辑中",
    "Edit_successfully": "编辑成功",
    "Edit_failure": "编辑失败",
    "Please_upload_the_attached_file": "请上传附带文件",
    "updating": "更新中",
    "Update_successfully": "更新成功",
    "Export_warehouse_orders_in_batches": "批量导出出库单",
    "Number_of_pieces_to_be_issued": "应出件数",
    "Platform": "平台",
    "Export_excel_data_in_batches": "批量导出excel数据",
    "Export_the_pdf_of_the_swap": "导出换标pdf",
    "Change_label_list": "换标列表",
    "Change_label_information_table": "换标信息表",
    "Error_table_of_label_change_information": "换标信息错误表",
    "List_of_unchanged_labels": "未换标列表",
    "Storage_location_area": "库位区域",
    "change_label_status": "换标状态",
    "operator": "操作人",
    "Error_cause": "错误原因",
    "Estimated_weight": "预计重量",
    "Estimated_volume": "预计方数",
    "abnormal_remark": "异常备注",
    "Number_of_items_that_should_be_shipped_out": "应出库件数",
    "Number_of_items_that_have_been_shipped_out": "已出库件数",
    "Number_of_items_that_have_not_been_shipped_out": "未出库件数",
    "Number_of_intercepted_items": "拦截件数",
    "Number_of_rejected_items": "拒收件数",
    "Number_of_items_that_should_have_outer_box_labels_changed": "应换外箱标件数",
    "Number_of_items_that_have_not_had_outer_box_labels_changed": "未换外箱标件数",
    "Batch_processing_abnormal_child_orders": "批量处理异常子单",
    "Appendix_to_authorization": "授权书附件",
    "Changing_attachment": "换标附件",
    "Edit_Excel_Content": "编辑Excel内容",
    "Multiple_separated_by_Chinese_commas": "多个用中文逗号分开,如：",
    "Old_shipment_number_information": "旧货件号信息",
    "Please_enter_remarks": "请输入备注",
    "Update_failure": "更新失败",
    "Please_wait_until_the_file_is_uploaded": "请等待文件上传完毕",
    "Edit_SKU": "编辑SKU",
    "replace_SKU_or_not": "是否更换SKU",
    "Change_total_quantity": "更换总件数",
    "Old_SKU": "旧SKU",
    "New_SKU": "新SKU",
    "Update_total_quantity": "更换总数量",
    "Add": "添加",
    "Confirm": "确认",
    "change": "更换",
    "Do_not_replace": "不更换",
    "Please_Enter_Old_SKU": "请输入旧SKU",
    "Please_Enter_New_SKU": "请输入新SKU",
    "Please_Enter_Total_Replacement_Quantity": "请输入更换总数量",
    "Total_Replacement_Quantity_Cannot_Be_Less_Than_0": "更换总数量不能小于0",
    "The_List_Cannot_Be_Empty": "列表不能为空",
    "Please_Enter_Quantity": "请输入数量",
    "Quantity_Cannot_Be_Less_Than_0": "数量不能小于0",
    "quantity_of_SKU_replacements": "sku更换件数",
    "Suspend_the_responsible_party_from_the_warehouse": "暂停出仓责任方",
    "Delivery_omission": "送仓遗漏",
    "Cancel_intercept": "取消拦截",
    "Cancel_delivery_omission": "取消送货遗漏",
    "client": "客户",
    "staff": "员工",
    "reason": "理由",
    "Cancel_intercept_processing": "取消拦截处理中",
    "Cancel_intercept_successfully": "取消拦截成功",
    "Failed_to_cancel_intercept": "取消拦截失败",
    "Delivery_missing_processing": "送仓遗漏处理中",
    "Delivery_of_missing_processing_completed": "送仓遗漏处理完成",
    "Failed_to_send_warehouse_missing_processing": "送仓遗漏处理失败",
    "Cancel_delivery_missing": "取消送仓遗漏中",
    "Cancel_delivery_missing_complete": "取消送仓遗漏完成",
    "Failed_to_cancel_delivery_omission": "取消送仓遗漏失败",
    "Setting_an_account_failed": "设置出账失败",
    "Set_the_account_successfully": "设置出账成功",
    "Change_the_shipment_number": "换标货件号",
    "Shipment_number_information": "货件号信息",
    "Charge_Off": "出账",
    "Set_up_an_account": "设置出账",
    "Number_of_delivery_pieces": "送仓件数",
    "Not_Set": "未设置",
    "Outstanding_account": "未出账",
    "Out_of_account": "已出账",
    "Check_SKU": "查看SKU",
    "Change_mark_or_not": "是否换标",
    "Total_number_of_label_changes": "换标总数量",
    "Actual_number_of_label_changes": "实际换标数量",
    "Number_of_repeated_label_changes": "重复换标数量",
    "old_sku": "旧SKU",
    "new_sku": "新SKU",
    "allNum": "总数量",
    "Label_the_outer_box_repeatedly": "外箱标重复贴标",
    "Cancel_the_repeated_labeling_of_the_outer_box_label": "取消外箱标重复贴标",
    "Whether_to_set_repeat_replacement": "是否设置重复更换",
    "The_outer_box_label_does_not_actually_change_the_label": "外箱标实际不换标",
    "Cancel_the_outer_box_label_actually_do_not_change_the_label": "取消外箱标实际不换标",
    "Set_the_actual_SKU_replacement_information": "设置SKU实际更换信息",
    "If_the_label_has_been_changed_before,_set_the_actual_number_of_label_changes": "如果之前出库单已经更换过标签，请设置实际换标件数",
    "Label_change_repeatedly": "标签重复换标",
    "Repeated_switching": "重复换标",
    "No_repeated_label_change": "无重复换标",
    "Document_source": "制单来源",
    "TC_Order_for_goods": "唐朝订单",
    "Straddle_horse": "跨运马",
    "Latin_horse": "拉丁马",
    "Export_the_outbound_order_for_the_secondary_partition": "导出二级分区出库单",
    "Export_pdf_test": "导出pdf（测试）",
    "Export_pdf_test2": "导出pdf（测试2）",
    "Update_remarks": "更新备注",
    "Export_the_cargo_trajectory_information_of_Mercadolix": "导出美客多货物轨迹信息",
    "Create_a_new_extraction_label": "新建提取标签",
    "filename": "文件名",
    "extract": "提取",
    "Delivery_date": "送仓日期",
    "file_type": "文件类型",
    "Edit_tag_number": "编辑标签号码",
    "Box_label_type": "箱标类型",
    "Extraction_in_progress": "提取中",
    "Extraction_successful": "提取成功",
    "Extraction_failure": "提取失败",
    "pagination": "页数",
    "pageNumber": "页码",
    "picture": "图片",
    "Tag_number": "标签号码",
    "PDF_link": "PDF链接",
    "Please_enter_the_label": "请输入标签",
    "add_label": "添加标签",
    "Merge_and_export_pdf_tags": "合并导出pdf标签",
    "Add_mode": "添加方式",
    "Add_source": "添加来源",
    "Export_the_label_of_the_first_level_partition_split_box": "导出一级分区拆分箱标",
    "Update_title": "更新标题",
    "Page_rectangular_box_cropping": "页面矩形框裁剪",
    "clip": "裁剪",
    "no_clip": "不裁剪",
    "Batch_download_the_label_of_the_first_level_partition_split_box": "批量下载一级分区拆分箱标",
    "Label_type": "标签类型",
    "Upload_the_segmented_file": "上传分割文件",
    "Ordinary_upload": "普通上传",
    "Special_Upload": "特殊上传",
    "Clear_uploaded_files": "清空上传文件",
    "Confirm_the_division": "确定分割",
    "Label_preview_image": "标签预览图",
    "Draggable_or_clickable": "可拖拽或点击",
    "Segmentation_failed": "分割失败",
    "Segmentation_completed": "分割完成",
    "Unable_to_obtain_the_file_address": "无法获取文件地址",
    "Filter_by_page_content": "按页面内容筛选",
    "filter": "筛选",
    "no_filter": "不筛选",
    "Please_delete_the_files_that_failed_to_be_split": "请删除分割失败的文件",
    "Total:": "共",
    "zhang": "张",
    "A_copy": "份",
    "The_number_of_items_rejected_from_the_warehouse": "出仓拒收件数",
    "container_number": "柜号",
    "loading_count": "装车数量",
    "scan_detail": "扫码详情",
    "Failed_to_get_scan_detail": "获取扫码详情失败",
    "Edit_the_cabinet_number_and_remarks": "编辑柜号和备注",
    "Average_inventory_age": "平均库龄",
    "Inventory_age_distribution": "库龄分布",
    "Inventory_age_ranking": "库龄排行",
    "Customer_goods_in_warehouse_quantity_ranking": "客户货物在仓数量排行",
    "Interval_days": "区间（天）",
    "quantity_in_stock": "库存数量",
    "Ratio": "占比",
    "loading": "加载中",
    "no_more_data": "没有更多数据了",
  },
  order: {
    "exchange_number": "转单号",
    "cargo_departure_time": "出库时间",
    "cargo_exit_hold": "出货仓库",
    "charge_output_state": "出货状态",
    "type_of_transport": "运输类型",
    "shipping_time": "发出时间",
    "status_of_receiving_products": "收货状态",
    "cargo_access_code": "入库编号",
    "load_exit_code": "出库编号",
    "pick_up_order_number/container_number": "提单号/柜号",
    "time_to_remove_containers": "提柜时间",
    "cargo_entry_time": "入库时间",
    "warehouse_management": "仓库操作",
    "old_reserve_area": "原存放区域",
    "reserve_area_now": "现存放区域",
    "secondary_shipment_number": "子运单号",
    "new_secondary_shipping_number": "新子运单号",
    "shipping_new/label": "新货件号/唛头",
    "length": "长",
    "width": "宽",
    "height": "高",
    "export_sheet": "导出面单",
    "export_outer_box_label": "导出唛头标签",
    "export_corresponding_secondary_shipping_sheet": "导出对应子单号面单",
    "export_corresponding_secondary_shipment/outer_box_label": "导出对应子货件号/唛头",
    "delivery_number": "运单号",
    "shipping/outer_box_label": "货件号/唛头",
    "export_data": "数据导出",
    "filter": "筛选",
    "reboot": "重置",
    "total_pieces/piece": "总件数/件",
    "total_volume/cubic_meters": "总体积/CBM",
    "total_weight/kg": "总重量/KG",
    "state": "状态",
    "handling": "操作",
    "Check": "查看",
    "volume/cubic_meters": "体积/CBM",
    "weight/kg": "重量/KG",
    "total_pieces": "总件数",
    "total_weight": "总重量",
    "total_volume": "总体积",
    "piece": "件",
    "Company_logo": "公司标识",
    "Cargo_status": "货物状态"
  },
  container: {
    "Print_partition_code": "打印分区码",
    "add_new_container": "添加新容器",
    "add": "添加",
    "delivery_number": "运单号",
    "container_code": "容器码",
    "secondary_shipping/secondary_outer_carton_label": "子货件号/子唛头",
    "volume": "容积",
    "edit": "编辑",
    "delete": "删除",
    "close": "关闭",
    "discharge": "下载",
    "Cancel": "取消",
    "confirm_on_delete_container": "确定删除容器",
    "edit_container": "编辑容器",
    "container_name": "容器名称",
    "save": "保存",
    "export_data": "数据导出",
    "filter": "筛选",
    "reboot": "重置",
    "total_pieces": "总件数",
    "related_shipping_quantity/pcs": "关联运单数/条",
    "secondary_shipment_number": "子运单号",
    "cargo_access_code": "入库编号",
    "piece": "件",
    "print_container_code": "打印容器码",
    "select_all": "全选",
    "Container_log": "容器日志",
    "batch_delete": "批量删除",
    "Transfer_record": "转移记录",
    "Large_area_code": "大区码",
    "pre_transfer": "转移前",
    "post_transfer": "转移后",
  },
  abnormalData: {
    "delivery_number": "运单号",
    "driving_type": "操作类型",
    "cargo_entry_time": "入库时间",
    "shipping/outer_box_label": "货件号/唛头",
    "Operating_deadline": "最迟操作时间",
    "pieces_uploaded_without_scanning": "未扫码更新件数",
    "paste_label": "贴标",
    "customers": "客户",
    "Salesman": "业务员",
    "secondary_shipment_number": "子运单号",
    "product_label": "产品标",
    "load_output_number": "出库单号",
    "cargo_departure_time": "出库时间",
    "time_to_remove_containers": "提柜时间",
    "related_shipping_quantity/pcs": "关联运单数/条",
    "Warehouse_output_quantity/pieces": "已出仓件数/件",
    "amount_of_strange": "异常数量",
    "successful_scan_parts": "已扫码件数",
    "parts_without_scanning": "未扫码件数",
    "person_responsible_for_shipping": "送仓负责人",
    "shipping_car_number": "送仓车牌号",
    "secondary_shipping/secondary_outer_carton_label": "子货件号/子唛头",
    "quantity_of_products/pieces": "产品数量/件",
    "cargo_entry_number": "入库单号",
    "warehouse_receipt_amount/piece": "已入仓件数/件",
    "pieces_of_strange": "异常件数",
    "pieces_without_charge_entry": "未入库件数",
    "type_of_transport": "运输类型",
    "pick_up_order_number/container_number": "提单号/柜号",
    "Data_export": "数据导出",
    "filter": "筛选",
    "reset": "重置",
    "piece": "件",
    "Total_volume": "总体积",
    "Total_weight": "总重量",
    "driving": "操作",
    "view": "查看",
    "out_warehouse_number": "出库单号",
    "title": "标题",
    "status": "状态",
    "Total": "总件数",
    "reject_number": "拒收件数",
    "intercept_number": "拦截件数",
    "creator": "创建人",
    "address": "地址",
    "create_time": "创建时间",
    "delivery_time": "送仓时间",
    "remark": "备注",
    "delete": "删除",
    "Are_you_sure_to_delete": "确定删除？",
    "cancel": "取消",
    "waiting_for_out_warehouse": "待出库",
    "warehousing": "出库中",
    "warehoused": "已出库",
    "out_warehouse_abnormally": "出库异常",
    "deleting": "删除中",
    "Successfully_deleted": "删除成功",
    "Failed_to_get_out_warehouse_list": "获取出库列表失败",
    "Deletion_failure": "删除失败",
    "Scan_list": "扫码列表",
    "batch_delivery": "批量出库",
    "out_warehouse_intercept": "出仓拦截",
    "Are_you_sure_to_out_warehouse?": "确定出库？",
    "File_list": "文件列表",
    "batch_download": "批量下载",
    "take_a_photo_and_send_back": "拍照回传",
    "download": "下载",
    "close": "关闭",
    "Reject_list": "拒收列表",
    "download_attachment": "下载附件",
    "edit": "编辑",
    "update_attachment": "更新附件",
    "print_out_warehouse_list": "打印出库单",
    "export_out_warehouse_list": "导出出库单",
    "Export_the_reject_list": "导出拒收列表",
    "all": "全部",
    "Scanned": "已扫描",
    "To_be_scanned": "待扫描",
    "rejection": "拒收",
    "Failed_to_get_out_warehouse_details": "获取出库详情失败",
    "Failed_to_get_scan_list": "获取扫码列表失败",
    "Please_check_first": "请先勾选",
    "Batch_delivery_successfully": "批量出库成功",
    "Batch_out_warehouse_unsuccessfully": "批量出库失败",
    "Failed_to_get_fileList": "获取文件列表失败",
    "File_is_empty": "文件为空",
    "Download_unsuccessfully": "下载失败",
    "Download_successfully": "下载成功",
    "The_attached_file_is_empty": "附件文件为空",
    "exporting": "导出中",
    "Export_successfully": "导出成功",
    "Export_unsuccessfully": "导出失败",
    "intercept_reason": "拦截原因",
    "intercepting": "出仓拦截中",
    "Intercept_successfully": "出仓拦截成功",
    "Edit_reject_reason": "编辑拒收原因",
    "reject_reason": "拒收原因",
    "editing": "编辑中",
    "Edit_successfully": "编辑成功",
    "Edit_failure": "编辑失败",
    "Update_attachment": "更新附件",
    "Please_upload_the_attached_file": "请上传附带文件",
    "Only_xls,_xlsx,_PDF_files_are_supported": "仅支持 xls, xlsx, PDF文件",
    "updating": "更新中",
    "Update_successfully": "更新成功",
    "Intercept_unsuccessfully": "出仓拦截失败",
    "Failed_to_get_warehousing_list": "获取入仓列表失败",
    "warehoused_number": "已入库件数",
    "volume": "体积/CBM",
    "weight": "重量/KG",
    "Failed_to_get_warehousing_details": "获取入仓详情失败",
    "confirm": "确定",
    "save": "保存",
    "Intercepted_number_of_out_warehouse": "出仓拦截件数",
    "Warehouse_area": "仓库区域",
    "uploader": "上传人",
    "Upload_time": "上传时间",
    "picture": "图片",
    "TC_sub-order_number": "TC子单号",
    "secondary_shipping": "子货件号",
    "modifier": "修改人",
    "modifier_time": "修改时间",
    "edit_order_number": "编辑单号",
    "please_enter_the_sub-order_number": "请输入子单号",
    "please_enter_the_secondary_shipping": "请输入子货件号",
  },
  baseSetting: {
    "add": "添加",
    "brand": "品牌",
    "boss/responsible_person": "负责人",
    "administrator": "监管人",
    "edit": "编辑",
    "Delete": "删除",
    "Sure_to_delete_car_information?": "确定删除车辆信息？",
    "Confirm": "确定",
    "Cancel": "取消",
    "add_car_info": "添加车辆信息",
    "car_number": "车牌号",
    "Car_type": "车辆类型",
    "Purchased_time": "购入时间",
    "all_people/everyone": "所有人",
    "regulator/administrator": "监管员",
    "save": "保存",
    "edit_car_info": "编辑车辆信息",
    "contact": "联系人",
    "phone_contact": "联系电话",
    "detailed_address": "详细地址",
    "add_classification_area": "添加分区",
    "secondary_sorting_quantity/pieces": "子分区数量/个",
    "number_of_pallets/pieces": "卡板数量/个",
    "maximum_capacity/cubic_meters": "最大容量/CBM",
    "sure_to_delete_area_F?": "确定删除F 区？",
    "classification_name": "分区名称",
    "maximum_capacity": "最大容量",
    "edit_warehouse_information": "仓库信息编辑",
    "warehouse_name": "仓库名称",
    "secondary_classification_area": "子分区",
    "add_secondary_sort_area": "添加子分区",
    "location_code": "库位码",
    "capacity_now": "当前容量",
    "Carboard": "卡板",
    "Add_carboard": "添加卡板",
    "Carboard_code": "卡板码",
    "Edit_carboard": "编辑卡板",
    "Carboard_name": "卡板名称",
    "edit_secondary_sort_area": "编辑子分区",
    "secondary_sort_area_name": "子分区名称",
    "close": "关闭",
    "download": "下载",
    "Total_number_of_pieces": "总件数",
    "shipping": "货件号",
    "delivery_number": "运单号",
    "secondary_shipment_number": "子运单号",
    "sure_to_delete": "确认删除",
    "area": "区",
    "Number_of_subarea": "分区数量/个",
    "Edit_subarea": "编辑分区",
    "Old_shipment_number": "旧货件号",
    "scanning_time": "扫码时间",
    "shelf": "货架",
    "Add_shelf": "添加货架",
    "Export_the_required_location_code_size": "导出所需的库位码尺寸",
    "Export": "导出",
    "Number_of_layers": "层数",
    "Add_layers": "添加层数",
    "location": "库位",
    "Add_location": "添加库位",
    "Failed_to_get_the_warehouse_shelf_list": "获取仓库货架列表失败",
    "Failed_to_get_the_layer_number_of_warehouse_list": "获取仓库层数列表失败",
    "Failed_to_get_the_warehouse_location_list": "获取仓库库位列表失败",
    "print": "打印",
    "Select_All": "全选中",
    "All_complete": "全选完成",
    "Please_select_the_print_item_first": "请先勾选打印项",
  },
  deliveryReservation: {
    "Daily_Reservation": "每日预约",
    "Last_month": "上个月",
    "today": "今天",
    "Next_month": "下个月",
    "Reservation_status": "预约情况",
    "piece": "件",
    "Daily_delivery": "每日送仓",
    "Delivery_instructions": "送仓须知",
    "Reservation_time": "预约时间",
    "Delivery_time": "送仓时间",
    "Shipment_number/shipping_mark": "货件号/唛头",
    "pieces": "件数",
    "Cancel_delivery": "取消送仓",
    "Confirm_whether_to_cancel_delivery": "是否确认取消送仓",
    "Successfully_cancel_delivery": "取消送仓成功",
    "Failed_to_cancel_delivery": "取消送仓失败",
    "Failed_to_get_data": "获取数据失败",
    "export": "导出",
    "exporting": "导出中",
    "Export_successfully": "导出成功",
    "Export_unsuccessfully": "导出失败",
    "delivery_number": "运单号",
    "shipping/outer_box_label": "货件号/唛头",
    "load_output_number": "出库单号",
    "filter": "筛选",
    "reset": "重置",
    "shipping": "货件号",
    "driving": "操作",
    "confirm": "确定",
    "cancel": "取消",
  },
  workorder: {
    "Work_order_number": "工单号",
    "Associated_order_number": "关联单号",
    "Operating_state": "操作状态",
    "work_order_node": "工单节点",
    "Work_order_type": "工单类型",
    "Problem_type": "问题类型",
    "Creation_time": "创建时间",
    "creator": "创建人",
    "Processing_department": "处理部门",
    "filter": "筛选",
    "reset": "重置",
    "customer_code": "客户代码",
    "Current_processing_department": "当前处理部门",
    "Current_processor": "当前处理人",
    "Associated_work_order": "关联工单",
    "Current_node_time": "当前节点耗时",
    "Total_time_spent": "总耗时",
    "Claim_time": "认领时间",
    "Prescription_of_claim": "认领时效",
    "Operating_time": "操作时间",
    "Description": "描述",
    "remark": "备注",
    "Latest_communication_content": "最新沟通内容",
    "view": "查看",
    "All": "全部",
    "Wait_to_be_done": "待办",
    "Have_done": "已办",
    "My_creation": "我的创建",
    "Copy_me": "抄送我的",
    "Withdrawn": "已撤回",
    "rejected": "已驳回",
    "submitted": "已提交",
    "finished": "已完结",
    "Obsolete": "已废弃",
    "Have_already_been_created": "已创建",
    "In_process": "处理中",
    "Failed_to_get_a_CC": "获取抄送失败",
    "Failed_to_get_the_work_order_type_list": "获取工单类型列表失败",
    "Failed_to_get_the_problem_type_list": "获取问题类型列表失败",
    "Failed_to_get_the_department_list": "获取部门列表失败",
    "Failed_to_get_the_employee_list": "获取员工列表失败",
    "Failed_to_get_the_work_order_list": "获取工单列表失败",
    "Failed_to_change_cc_status": "抄送状态变更失败",
    "Basic_information": "基础信息",
    "View_the_change_mark_requirements": "查看换标要求",
    "Attached_file": "附带文件",
    "Attached_picture": "附带图片",
    "Processing_information": "处理信息",
    "Whether_to_view": "是否查看",
    "Owning_warehouse": "所属仓库",
    "Communication_information": "沟通信息",
    "Communication_reply": "沟通回复",
    "issuer": "发出人",
    "Carbon_copy_recipient": "抄送人",
    "Communication_content": "沟通内容",
    "Claim_the_work_order": "认领工单",
    "Processing_work_order": "处理工单",
    "Work_order_processing_log": "工单处理日志",
    "unfold": "展开",
    "handle": "处理",
    "Pack_up": "收起",
    "processor": "处理人",
    "Check_the_time": "查看时间",
    "Node_time_consuming": "节点耗时",
    "Processing_remarks": "处理备注",
    "Are_you_sure_you_want_to_claim_a_work_order?": "确定要认领工单？",
    "confirm": "确定",
    "Cancel": "取消",
    "Are_you_sure_you_want_to_complete_a_work_order?": "确定要完结工单？",
    "source": "来源",
    "Whether_internal_work_order": "是否内部工单",
    "initiator": "发起人",
    "Commit_processing": "提交处理",
    "Finished_work_order": "完结工单",
    "Withdrawal_processing": "撤回处理",
    "Scrap_ticket": "废弃工单",
    "Failed_to_get_domain_name": "获取域名失败",
    "Failed_to_get_details": "获取详情失败",
    "Failed_to_get_chat_list": "获取聊天列表失败",
    "Failed_to_get_the_log_list": "获取日志列表失败",
    "Reason_for_withdrawal": "撤回原因",
    "Cause_of_rejection": "驳回原因",
    "Reason_for_abandonment": "废弃原因",
    "Claiming": "认领中",
    "Claim_successfully": "认领成功",
    "Failed_to_claim_the_work_order": "认领工单失败",
    "In_completion": "完结中",
    "Complete_success": "完结成功",
    "Failed_to_complete_the_work_order": "完结工单失败",
    "Number_of_packages": "件数",
    "Shipping_slip_number": "运单子单号",
    "Old_shipment_number": "旧货件号",
    "Shipping_mark": "唛头",
    "New_shipment_number": "新货件号",
    "Old_SKU_logo": "旧SKU标",
    "New_SKU_logo": "新SKU标",
    "Please_fill_in": "请填写",
    "required": "必填",
    "Picture_upload": "图片上传",
    "Only_support": "仅支持",
    "isoformat": "等图片格式",
    "Being_submitted": "提交中",
    "Submit_successfully": "提交成功",
    "Commit_failure": "提交失败",
    "Processing_result": "处理结果",
    "Failed_to_obtain_the_service_provider_list": "获取服务商列表失败",
    "task_code": "任务码",
    "Export_mark_handover": "导出换标交接",
    "Batch_assignment_work_order": "批量分配工单",
    "Added_to_download_list": "已添加到下载列表",
    "excel_export_failed": "导出excel失败",
    "Bind_suborders_in_batches": "批量绑定子单",
    "Confirm_binding": "确认绑定",
    "Processing_priority": "处理优先级",
    "Batch_export_of_goods_details": "批量导出货物详情",
  },
  error: {
    "Sorry_the_page_you_are_looking_for_is_missing": "抱歉，您要访问的页面丢失了",
    "To_check_whether_the_URL_you_entered_is_correct_please_click_the_button_below_to_return_to_the_home_page": "检查您输入的网址是否正确，请点击以下按钮返回首页",
    "Back": "返回"
  },
  loadingLot: {
    "delivery_number": "运单号",
    "shipping": "货件号",
    "creator": "创建人",
    "End_time_of_scanning_code": "扫码结束时间",
    "car_number": "车牌号",
    "filter": "筛选",
    "reset": "重置",
    "driving": "操作",
    "view": "查看",
    "batch_export": "批量导出",
    "lot_number": "批次编号",
    "Number_of_packages": "件数",
    "Create_time": "创建时间",
    "export_data": "数据导出",
    "lot_information": "批次信息",
    "total_pieces": "总件数",
    "Code_scanner": "扫码人",
    "Shipment_information": "货件信息",
    "Code_scanning_information": "扫码信息",
    "Code_scanning_failure_information": "扫码失败信息",
    "tc_order_number": "TC单号",
    "Shipment_number": "货件编号",
    "Number_of_items_to_be_shipped_out": "应出库件数",
    "Number_of_scanned_codes": "扫码件数",
    "Missing_pieces": "缺少件数",
    "Missing_number": "缺少的编号",
    "TC_sub-order_number": "TC子单号",
    "secondary_shipping": "子货件号",
    "scanning_time": "扫码时间",
    "Cause_of_failure": "失败原因",
    "transport_car_no": "车牌号",
    "create_user_realname": "创建人",
    "create_time": "创建时间",
    "number": "批次编号",
    "scan_count": "扫描件数",
  },
  returnGoods: {
    "Generate_a_single_barcode": "单个生成条形码",
    "Batch_barcode_generation": "批量生成条形码",
    "Shipment_number/shipping_mark": "货件号/唛头",
    "Input_example": "输入示例",
    "Please_enter": "请输入",
    "Start_number": "开始编号",
    "End_number": "结束编号",
    "Shipping_mark_delimiter": "唛头分隔符",
    "If_the_number_is_set_to_1-10,_it_will_be_generated_in_the_form_of_12345-1_to_12345-10": "如果编号填写的为1-10，则将以“12345-1~12345-10”这种形式生成",
    "Cancel": "取消",
    "print": "打印",
    "Export": "导出",
    "None": "无",
    "saving": "保存中",
    "printing": "打印中",
    "Print_successfully": "打印成功",
    "Failed_to_print": "打印失败",
    "exporting": "导出中",
    "Export_successfully": "导出成功",
    "Failed_to_export_the_sheet": "导出面单失败",
    "Platform_type": "平台类型",
    "Return_code": "退货码",
    "Number_of_packages": "件数",
    "Add": "添加",
    "Fill_in_optional": "选填",
    "Shipment_number": "货件号",
    "Delete": "删除",
    "Return_goods": "退货",
    "United_States_and_Mexico": "美墨",
    "Saving": "保存中",
    "Save_successfully": "保存成功",
    "Failed_to_save": "保存失败",
    "Failed_to_obtain_the_platform_type_list": "获取平台类型列表失败",
    "Please_select_the_platform_type!": "请选择平台类型！",
    "Failed_to_add_the_shipment_number": "添加货件号失败",
    "The_return_code_can_only_be_added_once": "退货码只能添加一遍",
    "Please_enter_the_correct_information!": "请输入正确信息！",
    "adding": "添加中",
    "Add_successfully": "添加成功",
    "Add_failure": "添加失败",
    "Return/US-Mexico_details": "退货/美墨详情",
    "TC_order_number": "TC单号",
    "Founder": "创建人",
    "Total_number_of_packages": "总件数",
    "Order_type": "订单类型",
    "Time_of_creation": "创建时间",
    "Order_information": "货件信息",
    "TC_sub-order_number": "TC子单号",
    "Sub-shipment_number": "子货件号",
    "Express_tracking_number": "快递单号",
    "Storage_location_information": "库位信息",
    "The_latest_update_time": "最新更新时间",
    "Updater": "更新人",
    "Cargo_picture": "货物图片",
    "Print_sheet": "打印面单",
    "Export_sheet": "导出面单",
    "Download": "下载",
    "Close": "关闭",
    "Failed_to_get_details": "获取详情失败",
    "Failed_to_obtain_form": "获取表格失败",
    "generate": "生成",
    "Express_Ticket_number": "快捷单号",
    "Warehousing_time": "入仓时间",
    "New_order": "新建订单",
    "Type_of_order": "订单类别",
    "Type_of_shipment": "货件类型",
    "Generate_barcode": "生成条形码",
    "View_size": "查看尺寸",
    "resize": "更新尺寸",
    "Private_person": "私人",
    "Address_template": "地址模板",
    "Upload_packing_list": "上传箱单",
    "Only_files_smaller_than_15_MB_are_supported": "仅支持小于15M文件",
    "Modify_size_information_in_batches": "批量修改尺寸信息",
    "Gross_weight": "毛重",
  },
  inventoryCenter: {
    "Edit_operation_time": "编辑操作时间",
    "Updated_in_Mexico_local_time": "更新的是墨西哥当地时间",
    "First_shelf_time_(manual)": "首次上架时间（手动）",
    "Takedown_time_(manual)": "下架时间（手动）",
    "Exit_time_(manual)": "出仓时间（手动）",
    "Warehousing_time_(manual)": "入仓时间（手动）",
    "Shelf_time": "上架时间",
    "Update_the_outbound_time": "更新出库时间",
    "Outbound_time_(Mexico_time)": "出库时间（墨西哥时间）",
  },
  transferWarehouse: {
    "order_number": "订单号",
    "shipping_mark": "唛头",
    "account_manager": "客户经理",
    "reception_time": "接收时间",
    "estimated_time_of_delivery": "预计送达时间",
    "order_status": "订单状态",
    "audit_status": "审核状态",
    "filter": "筛选",
    "reset": "重置",
    "operate": "操作",
    "view": "查看",
    "pending": "待审核",
    "audited": "已审核",
    "failed_to_get": "获取失败",
    "saving": "保存中",
    "saved_successfully": "保存成功",
    "failed_to_save": "保存失败",
    "order_information": "订单信息",
    "number_of_pieces": "货物件数",
    "creation_time": "创建时间",
    "shelf_start_time": "开始上架时间",
    "storage_age": "库龄",
    "finish_shelf_time": "完成上架时间",
    "place_of_dispatch": "起运地",
    "total_weight": "总重量",
    "receiver": "接收人",
    "destination_warehouse": "目的仓",
    "total_volume": "总体积",
    "customer_information": "客户信息",
    "customer_name": "客户名称",
    "contact_person": "联系人",
    "contact_number": "联系号码",
    "shipment_information": "货件信息",
    "total_actual_weight": "总实重",
    "total_volume(volume_weight)": "总材积(体积重)",
    "total_square(volume)": "总方数(体积)",
    "total_square(actual_weight_divided_by_300)": "总方数(实重除以300)",
    "total_quantity": "总数量",
    "shipment_status": "货件状态",
    "days_of_storage": "仓储天数",
    "hide": "收起",
    "expand": "展开",
    "tc_subtracking_number": "TC子单号",
    "sub_shipment_number/shipping_mark": "子货件号/唛头",
    "length_*_width_*_height_/cm": "长*宽*高/CM",
    "gross_weight_/kg": "毛重/KG",
    "scanned_picture": "过机图片",
    "scene_picture": "现场图片",
    "sku_name": "SKU名称",
    "number_of_single_box": "单箱个数",
    "view_picture": "查看图片",
    "receive_information": "接收信息",
    "shipping_contact": "送货联系人",
    "shipping_contact_number": "送货联系号码",
    "receive_signature_picture": "接收签名图片",
    "receive_picture": "接收图片",
    "repudiator": "拒收人",
    "rejection_time": "拒收时间",
    "rejection_instructions": "拒收说明",
    "explanatory_picture": "说明图片",
    "remark_information": "备注信息",
    "customer_remarks": "客户备注",
    "internal_remarks": "内部备注",
    "print_sheet": "打印面单",
    "export_sheet": "导出面单",
    "export_warehouse_list": "导出入仓单",
    "export_customer_box_list": "导出客户箱单",
    "export_customer_service_box_list": "导出客服箱单",
    "export_attachment": "导出附件",
    "off": "关闭",
    "download": "下载",
    "new_sub_shipment_number/shipping_mark": "新子货件号/唛头",
    "change_type": "变更类型",
    "old_sub_shipment_number/shipping_mark": "旧子货件号/唛头",
    "original_product_label": "原产品标",
    "new_product_label": "新产品标",
    "quantity": "数量",
    "change_area": "变更区域",
    "uploading": "上传中",
    "upload_successfully": "上传成功",
    "failed_to_upload": "上传失败",
    "removing": "移除中",
    "removed_successfully": "移除成功",
    "failed_to_remove": "移除失败",
    "syncing": "同步中",
    "sync_successfully": "同步成功",
    "failed_to_sync": "同步失败",
    "no_data_available": "暂无数据",
    "exporting": "导出中",
    "warehouse_list": "入仓单",
    "added_to_the_download_queue": "已加入下载队列",
    "failed_to_export": "导出失败",
    "printing": "打印中",
    "print_successfully": "打印成功",
    "failed_to_print": "打印失败",
    "piece": "件",
    "number_of_packages": "件数",
    "express_sheet": "面单",
    "reject_information": "拒收信息",
    "delivery_information": "送仓信息",
    "operator": "操作人",
    "operate_status": "操作状态",
    "process_time": "处理时间",
    "picture": "图片",
    "remark": "备注",
    "accept": "接受",
    "reject": "拒绝",
    "picture_error,_please_contact_staff!": "图片错误，请联系工作人员！",
    "New_order": "新建订单",
    "Order_type": "订单分类",
    "Edit_order_category": "编辑订单分类",
    "Batch_delete": "批量删除",
    "Batch_audit": "批量审核",
    "Batch_counter_audit": "批量反审核",
    "Are_you_sure_you_want_to_do_a_batch_audit": "确定要进行批量审核操作吗？",
    "Are_you_sure_you_want_to_do_a_batch_counter_audit": "确定要进行批量反审核操作吗？",
    "add": "新建",
    "Delete": "删除",
    "confirm": "确定",
    "cancel": "取消",
    "delete_remarks": "删除备注",
    "I_ll_think_about_it_again": "我再想想",
    "Submit_successfully": "提交成功",
    "Commit_failure": "提交失败",
    "Please_check_first": "请先勾选",
    "deleting": "删除中",
    "Successfully_deleted": "删除成功",
    "Deletion_failure": "删除失败",
    "In_operation": "操作中",
    "operation_succeeded": "操作成功",
    "operation_failure": "操作失败",
    "edit": "编辑",
    "status": "状态",
    "Warehousing_time": "入仓时间",
    "Subsingle_column_table": "子单列表",
    "Number_of_products_tag": "货件号/唛头",
    "son_order_number": "子单号",
    "export": "导出",
    "Total_number_of_packages": "总件数",
    "Manifest_Agent": "货件信息",
    "Add_Manifest_Agent": "新增货件信息",
    "edit_size": "编辑尺寸",
    "Upload_customer_service_box_list": "上传客服箱单",
    "Only_files_smaller_than_15_MB_are_supported": "仅支持小于15M文件",
    "Synchronize_customer_service_box_list": "同步客服箱单",
    "Are_you_sure_you_want_to_delete": "确定要进行删除操作吗？",
    "Failed_to_get_order_classification": "获取订单分类失败",
    "Failed_to_get_details": "获取详情失败",
    "Failed_to_obtain_the_goods_information_Procedure": "获取货物信息失败",
    "Data_acquisition_failure": "获取数据失败",
    "Failed_to_export_the_sheet": "导出面单失败",
    "Customer_contact": "客户联系人",
    "Start_number": "开始编号",
    "End_number": "结束编号",
    "serial_number": "编号",
    "length_width_height": "长*宽*高",
    "weight": "重量",
    "add_SKU": "添加SKU",
    "Platform": "平台",
    "Batch_modify": "批量修改子货件号规格",
    "Length_CM": "长/CM",
    "Width_CM": "宽/CM",
    "Height_CM": "高/CM",
    "Weight_KG": "毛重/KG",
    "Confirm": "确认",
    "submit_order": "提交订单",
    "adding": "新增",
    "Lieferumfang": "货件号",
    "unfold": "展开",
    "Pack_up": "收起",
    "Being_submitted": "提交中",
    "Failed_to_obtain_the_customer_name_Procedure": "获取客户名称失败",
    "Description_Failed_to_obtain_the_account_manager": "获取客户经理失败",
    "Failed_to_obtain_the_customer_contact_Procedure": "获取客户联系人失败",
    "Failed_to_obtain_contact": "获取联系人失败",
    "Platform_acquisition_failure": "获取平台失败",
    "Number_already_exists": "编号已存在",
    "New_failed": "新增失败",
    "Please_select_the_customer_name_first": "请先选择客户名称",
    "Failed_to_obtain_customer_details": "获取客户详情失败",
    "Please_enter_SKU_number_or_name_search": "请输入SKU编号/名称搜索",
    "sku_code": "SKU编号",
    "selected_sku_count": "已选SKU数量",
    "Add": "添加",
    "aggregate": "总计",
    "true_weight": "实重",
    "volumes": "材积（体积重）",
    "Number_of_squares_300": "方数（实重除以300）",
    "Get_the_results": "获取计算结果",
    "save": "保存",
    "Failed_to_obtain_the_calculation_result_Procedure": "获取计算结果失败",
    "Edit_Customer_information": "编辑客户信息",
    "contact_person_ensp": "联 系 人",
    "Edit_Sizes": "编辑尺寸",
    "Sub_shipment_number": "子货件号",
    "Failed_to_get_the_SKU_list": "获取SKU列表失败",
    "upload_attachment": "上传附件",
  },
  other: {
    "batch_intercept": "批量拦截",
    "view_excel_content": "Excel内容查看",
    "tc_order_number": "TC单号",
    "tc_order_id": "TC编号",
    "Shipments_sent_to_Full_or_FBA": "送仓的货件",
    "change_mark": "换标",
    "hour": "小时",
    "Export_location_information_(trial)": "导出库位信息(试用)",
    "have_joined_downlod_queue": "已加入下载队列",
    "Edit_information": "编辑信息",
    "Confirm_the_changes?": "确认修改？",
    "Please_enter_search_criteria": "请输入搜索条件",
    "search": "搜索",
    "return_claim": "退货认领",
    "return_code": "退货码",
    "Shipment_number": "货件编号",
    "export_multi_subarea_outwarehouse_order_list": "导出出库单多分区",
    "secondary_shipment/outer_box_label": "子货件号/唛头",
    "pcs": "条",
    "Failed_to_get": "获取失败",
    "Please_enter_the_license_plate_number": "请输入车牌号",
    "Please_select_the_purchase_time": "请选择购入时间",
    "Are_you_sure_to_add_another_layer_to_this_shelf?": "确认在该货架添加一层？",
    "Are_you_sure_to_add_a_storage_location_on_this_shelf?": "确认在该货架该层数添加一个库位？",
    "Are_you_sure_to_delete_this_shelf?": "确认删除该货架？",
    "Are_you_sure_to_delete_the_maximum_number_of_shelves?": "确认删除该货架最高层层数？",
    "Are_you_sure_to_delete_this_storage_location?": "确认删除该库位？",
    "Shelf_name": "货架名称",
    "the_number_of_columns_of_location": "库位列数",
    "single": "单个",
    "batch": "批量",
    "Add_a_new_container": "单个添加新容器",
    "Please_enter_the_container_code": "请输入容器码",
    "The_container_code_is_too_long_Please_re_enter_it": "容器码过长,请重新输入",
    "Add_new_containers_in_batches": "批量添加新容器",
    "quantity": "数量",
    "Please_enter_quantity": "请输入数量",
    "warehouse": "仓库",
    "uploading": "上传中",
    "upload_successfully": "上传成功",
    "failed_to_upload": "上传失败",
    "out_warehouse": "出仓",
    "Sure_out_warehouse?": "确定出仓？",
    "Dispatching": "出仓中",
    "Successfully_dispatched_from_storage": "出仓成功",
    "Dispatched_from_the_warehouse_unsuccessfully": "出仓失败",
    "Reject_the_ticket": "驳回工单",
    "If_final_processing_is_complete,_select_the_processor_to_make_the_response_(required)": "若最终处理完成，则选择发起人反馈情况（必填）",
    "Interior": "内部",
    "Outside": "外部",
    "Cargo_information": "货物信息",
    "Export_Cargo_information": "导出货物信息",
    "inventory_anomaly": "盘点异常",
    "reprint": "重复打印",
    "twice": "两次",
    "Batch_update_title": "批量更新标题",
    "No_file": "暂无文件",
    "batch_delete": "批量删除",
    "You_have_selected": "你勾选了",
    "pieces_of_document_information_Are_you_sure_you_want_to_delete_them": "条单据信息，是否确认删除",
    "In_operation": "操作中",
    "Batch_deletion_succeeded": "批量删除成功",
    "Batch_deletion_failed": "批量删除失败",
    "add": "新增",
    "sku_code": "SKU编码",
    "customer_name": "客户名称",
    "time": "时间",
    "driving": "操作",
    "view": "查看",
    "SKU_quantity_*_Unit_price": "SKU数量*单价",
    "fail_to_get": "获取失败",
    "Picking_situation": "拣货情况",
    "date": "日期",
    "abnormal_condition": "异常情况",
    "total_number_of_packages": "总件数",
    "Pick_volume_in_the_last_seven_days": "近七天的拣货量",
    "line_chart": "折线图",
    "histogram": "柱状图",
    "Number_of_pending_orders": "待拣货订单数量",
    "Order_quantity_in_picking": "拣货中订单数量",
    "Quantity_shipped_out_today": "今日已出库数量",
    "Refuse_to_return_to_warehouse": "拒收回仓",
    "Number_of_unpacked_shelves": "拆包上架数量",
    "Quantity_of_original_package_transfer": "原包转单数量",
    "Pick_list_number": "拣货单号",
    "type": "类型",
    "generated_time": "生成时间",
    "creation_time": "创建时间",
    "order_quantity": "订单数量",
    "Total_number_of_SKUs": "SKU总数量",
    "filter": "筛选",
    "reset": "重置",
    "Print_the_pick_list": "打印拣货单",
    "Are_you_sure_you_want_to_generate_a_pick_list": "确定要生成拣货单吗",
    "Select": "请选择",
    "print_setup": "打印设置",
    "Print_without_preview": "无预览打印",
    "Printer_name": "打印机名称",
    "Size_input_method": "尺寸输入方式",
    "Paper_size_W_H_mm": "纸张尺寸（宽*高）/mm",
    "Print_test": "打印测试",
    "Open": "开启",
    "Close": "关闭",
    "Default": "默认",
    "Custom": "自定义",
    "Connect_to_the_client_first": "请先连接客户端!",
    "Please_select_a_printer": "请选择打印机",
    "New_cargo_specification": "新建货物规格",
    "order_information": "订单信息",
    "batch_number": "批次号",
    "state": "状态",
    "number_of_pieces": "货物件数",
    "audit_status": "审核状态",
    "Outer_box_label_change_status": "外箱标换标状态",
    "Number_of_containers_to_be_replaced": "需换外箱标件数",
    "The_number_of_changed_packets": "已换标件数",
    "Number_of_replacement_products": "换产品标件数",
    "Total_number_of_products_that_need_to_be_replaced": "需换产品标总件数",
    "Subsingle_column_table": "子单列表",
    "delivery_number": "运单号",
    "shipping": "货件号",
    "Number_of_products_tag": "货件号/唛头",
    "son_order_number": "子单号",
    "export": "导出",
    "change_label_status": "换标状态",
    "Change_mark_cut_off_state": "换标截止状态",
    "Set_the_mark_change_cutoff_state": "设置换标截止状态",
    "goods_info": "货件信息",
    "Added_the_specification_information_of_cargo_change": "新增货物换标规格信息",
    "download_attachment": "下载附件",
    "edit": "编辑",
    "Check_SKU": "查看SKU",
    "delete": "删除",
    "export_label_pdf": "导出换标PDF",
    "Are_you_sure_you_want_to_delete": "确定要进行删除操作吗？",
    "I_ll_think_about_it_again": "我再想想",
    "confirm": "确定",
    "cancel": "取消",
    "Not_yet_closed": "未截止",
    "expired": "已截止",
    "No_change_of_mark": "未换标",
    "Changed_mark": "已换标",
    "To_be_changed": "待换标",
    "changeLabeling": "换标中",
    "save": "保存",
    "saving": "保存中",
    "Save_successfully": "保存成功",
    "Save_unsuccessfully": "保存失败",
    "failed_to_get": "获取失败",
    "Please_check_first": "请先勾选",
    "exporting": "导出中",
    "Export_successfully": "导出成功",
    "Export_unsuccessfully": "导出失败",
    "Failed_to_get_details": "获取详情失败",
    "Failed_to_obtain_the_goods_information_Procedure": "获取货物信息失败",
    "no_data_available": "暂无数据",
    "Failed_to_export_the_sheet": "导出面单失败",
    "printing": "打印中",
    "Print_successfully": "打印成功",
    "Failed_to_print": "打印失败",
    "deleting": "删除中",
    "Successfully_deleted": "删除成功",
    "Deletion_failure": "删除失败",
    "Download_unsuccessfully": "下载失败",
    "Number_of_items_that_should_have_outer_box_labels_changed": "应换外箱标件数",
    "should_sku_num": "应换SKU件数",
    "Are_you_sure_you_want_to_delete_it": "确定要删除吗",
    "New_shipment": "新建货件",
    "Added_shipment_specification_information": "新增货件规格信息",
    "Mark_change_requirement": "换标需求",
    "The_outer_box_label_is_replaced_one_by_one": "外箱标强制一对一更换",
    "Platform_type": "平台类型",
    "Change_the_new_shipment_number": "换标新货件号",
    "Change_the_shipment_number": "换标货件号",
    "If_you_only_change_the_product_label_do_not_fill_in": "如只换产品标则可不填写",
    "query": "查询",
    "Please_re_check": "如果修改“换标需求类型”和“平台类型”，请重新查询",
    "hide": "收起",
    "expand": "展开",
    "original_product_label": "原产品标",
    "new_product_label": "新产品标",
    "number": "个数",
    "add_product": "新增产品标",
    "remark": "备注",
    "Label_file_upload": "贴换标文件上传",
    "Delete_shipment_specifications": "删除货件规格",
    "submit": "提交",
    "Failed_to_obtain_the_platform_type_Procedure": "获取平台类型失败",
    "Replace_the_outer_box_label": "更换外箱标",
    "Change_product_label": "更换产品标",
    "Replace_the_outer_box_label_and_product_label": "更换外箱标及产品标",
    "Query_failure": "查询失败",
    "Please_select_the_platform_type!": "请选择平台类型",
    "Please_select_an_address_type": "请选择地址类型",
    "Please_add_shipment": "请添加货件",
    "Please_fill_in_the_number_of_product_labels_correctly": "请正确填写产品标个数",
    "Please_fill_in_the_new_product_label": "请填写新产品标",
    "Please_fill_in_the_original_product_label": "请填写原产品标",
    "The_new_and_old_package_numbers_are_not_equal": "新旧货件号数量不相等",
    "Please_check_the_new_shipment_number": "请对新货件号进行查询",
    "Please_enter_the_new_shipment_number": "请输入新货件号",
    "Quantity_mismatch": "数量不匹配",
    "Duplicate_subshipment_numbers_exist_Procedure": "存在重复子货件号",
    "Please_enter_data": "请输入数据",
    "Being_submitted": "提交中",
    "Submit_successfully": "提交成功",
    "Commit_failure": "提交失败",
    "Edit_cargo_information": "编辑货物信息",
    "Change_mark_or_not": "是否换标",
    "Total_number_of_label_changes": "换标总数量",
    "Edit_SKU": "编辑SKU",
    "replace_SKU_or_not": "是否更换SKU",
    "Change_total_quantity": "更换总件数",
    "Old_SKU": "旧SKU",
    "New_SKU": "新SKU",
    "Update_total_quantity": "更换总数量",
    "allNum": "总数量",
    "Confirm": "确认",
    "Add": "添加",
    "Old_SKU_repeat": "旧SKU重复",
    "Set_the_storage_start_time": "设置仓储起始时间",
    "Set_storage_end_time": "设置仓储结束时间",
    "Failed_to_get_list": "获取列表失败",
    "outwarehouse_time": "出仓时间",
    "storage_time": "仓储时间",
    "number_of_squares": "方数",
    "Warehousing_start_time": "仓储开始时间",
    "storage_time": "仓储时间",
    "weight": "重量",
    "End_of_storage_time": "仓储结束时间",
    "Billing_phase": "计费阶段",
    "Restocking_stage": "更新仓储阶段",
    "Warehousing_reason": "仓储原因",
    "Calculate_storage_charges": "计算仓储费",
    "Charging_remarks": "计费备注",
    "Warehouse_remarks": "仓储备注",
    "charging": "计费",
    "no_charging": "不计费",
    "start_time": "开始时间",
    "end_time": "结束时间",
    "Updated_in_Mexico_local_time": "更新的是墨西哥当地时间",

    // 新翻译
    "order_number": "订单号",
    "Picking_condition": "拣货状态",
    "creation_time": "创建时间",
    "Added_pick_list": "新增拣货单",
    "Print_the_express_receipt": "打印快递面单",
    "Add_ing": "新增中",
    "Add_success": "新增成功",
    "Add_failure": "新增失败",
    "Please_scan_the_SKU_code": "请扫描SKU编码",
    "print": "打印",
    "batch_delivery": "批量出库",
    "outwarehouse": "出库",
    "Are_you_sure_to_leave_the_warehouse": "确定出库吗",
    "operation_succeeded": "操作成功",
    "operation_failure": "操作失败",
    "order_list": "订单列表",
    "sku_pick_list": "SKU拣货列表",
    "Scan_or_enter_the_container_code": "请扫描或输入容器码",
    "serial_number": "序号",
    "container_info": "容器信息",
    "scan_out": "扫描出单",
    "sku_code": "SKU编号",
    "sku_total": "SKU总件数",
    "numeration": "编号",
    "sku_total_quantity": "SKU总数量",
    "Unprinted_quantity": "未打印数量",
    "picking_bill": "拣货单",
    "Failed_to_obtain_the_label_library_location_Procedure": "获取标签库位信息失败",
    "Length": "长",
    "Width": "宽",
    "Height": "高",
    "Weight": "重量",
    "Basic_information": "基础信息",
    "Pick_list_number": "拣货单编号",
    "Platform_order_number": "平台订单号",
    "Express_tracking_number": "快递单号",
    "Platform": "平台",
    "tespackaging_informationt": "包装信息",
    "Shipping_information": "送货信息",
    "contact_person": "联系人",
    "phone_contact": "联系电话",
    "address": "地址",
    "telephone": "电话",
    "city": "城市",
    "sku_info": "SKU信息",
    "product_name": "商品名称",
    "Scan_or_enter_the_SKU_code": "请扫描或输入SKU编码",
    "Exit_scan": "退出扫描",
    "Scan_and_print_the_order": "扫描打单",
    "If_the_popup_window_closes_before_the_goods_have_been_scanned_rescan_is_required": "弹窗如果在货物未扫描完成时关闭，则需重新扫描",
    "quantity_swept": "已扫数量",
    "quantity_unswept": "未扫数量",
    "Please_enter_the_SKU_code": "请输入SKU编码",
    "Library_location_number": "库位号",
    "Shelf_time": "上架时间",
    "location": "库位",
    "operator": "操作人",
    "Operating_time": "操作时间",
    "goods_stock": "货物库存",
    "secondary_shipment_number": "子运单号",
    "Sub_shipment_number": "子货件号",
    "sku_inventory": "sku库存",
    "quantity_of_goods": "货物数量",
    "sku_quantity": "sku数量",
    "sku_code_quantity": "sku编码数量",
    "Failed_to_obtain_the_container_list_Procedure": "获取容器列表失败",
    "Failed_to_export_the_container_list_Procedure": "导出容器列表失败",
    "Warehousing_time": "入仓时间",
    "Adjustment_order_number": "调整单号",
    "goods_price": "货物价格",
    "new_construction": "新建",
    "Please_enter": "请输入",
    "unit_price": "单价",
    "summation": "合计",
    "Order_number_SKU_code": "订单号/SKU编码",
    "name": "名称",
    "Library_location_log": "库位日志",
    "Failed_to_obtain_log": "获取日志失败",
    "edit_warehouse_information": "仓库信息编辑",
    "warehouse_name": "仓库名称",
    "maximum_capacity": "最大容量",
    "detailed_address": "详细地址",
    "editing": "编辑中",
    "Edit_successfully": "编辑成功",
    "Edit_failure": "编辑失败",
    "driving_type": "操作类型",
    "order_time": "下单时间",
    "price": "价格",
    "shelf_a_product_to_stock": "上架库存",
    "sku_picking_up_goods": "拣货中SKU",
    "delivery_record": "出库记录",
    "bar_code_printer": "打印条码",
    "Whether_the_goods_have_been_picked": "是否已拣货",
    "weighting": "称重",
    "measure_the_volume": "测量体积",
    "odd": "单号",
    "yes": "是",
    "no": "否",
    "expense_rule": "费用规则",
    "country": "国家",
    "coefficient": "系数",
    "currency": "币种",
    "Maximum_unilateral_length": "最大单边长",
    "Update": "更新",
    "The_first_weight": "首重",
    "minimum_weight": "最小重量",
    "maximum_weight": "最大重量",
    "Stepping": "步进",
    "Stepping_price": "步进价格",
    "Added_to_download_list": "已添加至下载列表",
    "Enterprise_management_background": "企业管理后台",
    "log": "日志",
    "Current_storage_location": "当前库位",
    "Old_storage_location": "旧库位",
    "operant_hehavior": "操作行为",
    "Storage_location_status": "库位状态",
    "Operating_remarks": "操作备注",
    "Query_source": "查询来源",
    "Old_inventory": "旧库存",
    "New_inventory": "新库存",
    "Failed_to_obtain_partition_query_data_Procedure": "获取分区查询数据失败",
    "Connect_to_the_client_first_and_then_print": "请先连接客户端，再执行打印",
    "upload": "上传",
    "download": "下载",
    "source": "来源",
    "cargo_entry_time": "入库时间",
    "Export_the_goods_data_of_the_warehouse_receipt": "导出入库单货物数据",
    "Transport_type": "运输类型",
    "export_list": "导出列表",
    "Be_put_in_storage": "入库中",
    "All": "全部",
    "Confirm_the_modification": "确认修改吗",
    "warehousing": "入库",
    "shelving": "上架",
    "inventory_checking": "盘点",
    "current_state": "当前状态",
    "Available_today_piece": "今日上架/件",
    "Todays_inventory_piece": "今日盘点/件",
    "Failed_to_obtain_warehouse_data_time_analysis_data_Procedure": "获取仓库数据时间分析数据失败",
    "Failed_to_obtain_warehouse_partition_data": "获取仓库分区数据失败",
    "Failed_to_obtain_the_card_list_Procedure": "获取卡板列表失败",
    "Failed_to_obtain_warehouse_partition_details_Procedure": "获取仓库分区详情失败",
    "Commercial_Bill_of_Lading": "提货商",
    "Waybill_quantity": "运单数量",
    "cargo_departure_time": "出库时间",
    "Outbound_status": "出库状态",
    "customer_remarks": "客户备注",
    "Customer_service_remarks": "客服备注",
    "Warehouse_Remarks": "仓库备注",
    "attachment": "附件",
    "Batch_confirmation_out_warehouse": "批量确认出仓",
    "Batch_cancel_out_warehouse": "批量取消出仓",
    "edit_remarks": "编辑备注",
    "TC_order_number": "TC订单号",
    "shipping_mark": "唛头",
    "sku_name": "SKU名称",
    "waiting_for_out_warehouse": "待出库",
    "Out_of_storage": "已出库",
    "Are_you_sure_to_batch_confirm_the_shipment": "确定要批量确认出仓吗",
    "Are_you_sure_you_want_to_cancel_the_shipment_in_bulk": "确定要批量取消出仓吗",
    "Attachment_upload_status": "附件上传状态",
    "Pickup_or_not": "是否自提",
    "The_waybill_has_been_handed_over_to_the_consignee_before_delivery": "操作出库前，请确认当前拣货批次中的所有运单已交给提货商",
    "Batch_order_number": "批次单号",
    "haven_t_uploaded": "未上传",
    "have_already_uploaded": "已上传",
    "pick_up_in_a_store": "自提",
    "Distribution_collection_point": "配送集货点",
    "One_out_of_the_warehouse": "一件代发出库",
    "Failed_to_obtain_the_customer_name_list": "获取客户名称列表失败",
    "Added_to_download_list": "已添加到下载列表",
    "Please_select_an_address_template": "请选择地址模板",
    "export_data": "数据导出",
    "total_pieces_piece": "总件数/件",
    "total_volume_cubic_meters": "总体积/CBM",
    "total_weight_kg": "总重量/KG",
    "Update_failure": "更新失败",
    "Shipment_no_number": "货件号编号",
    "Failed_to_obtain_the_warehouse_partition_list_Procedure": "获取仓库分区列表失败",
    "Failed_to_obtain_warehouse_details": "获取仓库详情失败",
    "Add_Layer": "添加层",
    "Number_of_layers": "层数",
    "Add_location": "添加库位",
    "location_count": "库位数",
    "Failed_to_get_the_vehicle_list": "获取车辆列表失败",
    "Add_warehouse_Information": "添加仓库信息",
    "Edit_warehouse_Information": "编辑仓库信息",
    "pending": "待审核",
    "audited": "已审核",
    "Failed_to_get_the_order_list": "获取订单列表失败",
    "Failed_to_obtain_shipment_warehouse": "获取出货仓库失败",
    "Failed_to_obtain_the_shipping_type_Procedure": "获取运输类型失败",
    "Edit_the_shipment_number": "编辑货件号",
    "Merge_suborder": "合并子单",
    "Please_enter_the_TC_suborder": "请输入TC子单",
    "detection": "检测",
    "Subshipment_number_data": "子货件号数据",
    "suborder_data": "子单数据",
    "scanning_time": "扫码时间",
    "Takedown_time": "下架时间",
    "Return_time": "回仓时间",
    "Data_confirmed_after_merging": "合并后数据确认",
    "Definite_merge": "确定合并",
    "Merger_ing": "合并中",
    "Merger_successful": "合并成功",
    "Merge_failure": "合并失败",
    "detection_failure": "检测失败",
    "The_suborder_determines_the_status": "子单确定状态",
    "uncertain": "未确定",
    "confirmed": "已确定",
    "storage_age": "库龄",
    "Check_the_stream": "查看流水",
    "Settlement_of_storage_charges": "仓储费结算",
    "Termination_of_charge": "终止计费",
    "tc_subtracking_number": "TC子单号",
    "Cargo_flow": "货物流水",
    "movement": "动作",
    "operator2": "操作员",
    "secondary_shipping/secondary_outer_carton_label": "子货件号/子唛头",
    "Warehouse_area": "仓库区域",
    "other_description": "其他描述",
    "Whether_to_request_destruction": "是否请求销毁",
    "scan_time": "扫描时间",
    "Are_you_sure_to_destroy_the_goods": "确定销毁货物吗",
    "Failed_to_get_the_inventory_status_list": "获取库存状态列表失败",
    "Failed_to_obtain_the_database_location_list_Procedure": "获取库位列表失败",
    "Update_the_outbound_time": "更新出库时间",
    "The_number_of_squares_is_zero": "方数为零",
    "Weight_zero": "重量为零",
    "Export_the_customer_box_label": "导出客户箱标",
    "Estimated_time_of_arrival": "预计入仓时间",
    "Failed_to_obtain_the_SKU_list_Procedure": "获取SKU列表失败",
    "Failed_to_obtain_system_details": "获取系统详情失败",
    "Are_they_all_out_of_storage_If_the_product_is_missing_please_enter_the_details_to_specify_the_outlet": "是否全部出库？如果缺少产品，请进入详情指定出库",
    "All_out": "全部出库",
    "Assigns_the_storehouse": "指定出库",
    "Generate_a_pick_list": "生成拣货单",
    "Allocation_status": "配货状态",
    "not_generate": "未生成",
    "generated": "已生成",
    "Delivery_date": "送仓日期",
    "Number_of_containers_that_have_been_replaced": "已换外箱标件数",
    "Product_label_change_status": "产品标换标状态",
    "Number_of_replaced_product_standards": "已换产品标件数",
    "Need_to_change_the_outer_box_label": "需换外箱标",
    "Need_to_change_the_product_label": "需换产品标",
    "Whether_the_label_has_been_changed": "是否已换标",
    "converted_quantities": "已换数量",
    "Unchanged_quantity": "未换数量",
    "Number_of_products_that_need_to_be_replaced": "需换产品标件数",
    "Change_the_SKU": "换标SKU",
    "Old_shipment_number": "旧货件号",
    "New_shipment_number": "新货件号",
    "The_shipment_number_has_been_replaced": "已换货件号",
    "No_replacement_package_number": "未换货件号",
    "The_subshipment_number_should_be_changed": "应换子货件号",
    "Label_change_operation_logs": "换标操作日志",
    "Shipment_number_change": "货件号换标",
    "sku_change": "sku换标",
    "Description_Failed_to_obtain_the_label_change_operation_log": "获取换标操作日志失败",
    "Reload_attachment_information_succeeded_Procedure": "重载附件信息成功",
    "Failed_to_reload_attachment_information_Procedure": "重载附件信息失败",
    "Reload_attachment": "重载附件",
    "Has_the_outbound_order_been_exported": "是否导出过出库单",
    "classify": "分类",
    "outbound_delivery_order": "出库单",
    "label": "标签",
    "Batch_download_the_outbound_order_information": "批量下载出库单信息",
    "Obtain_information": "获取信息",
    "Achieve_success": "获取成功",
    "Achieve_failure": "获取失败",
    "Obtaining": "获取中",
    "Information_has_been_obtained_Please_click_to_export": "信息已获取完成，请点击导出",
    "Whether_to_split": "是否拆分",
    "Split_files": "拆分件数",
    "conditional_split": "拆分条件",
    "taskname": "任务名",
    "number_of_packages": "件数",
    "create_user_realname": "创建人",
    "create_search_goods_task_task": "新建找货任务",
    "add_search_goods_task_task": "添加找货任务",
    "List_of_goods_search_information": "找货信息列表",
    "Batch_input_suborder_numbers": "批量输入子单号",
    "Export_the_work_order_description": "导出工单描述",
    "Delivery_item_number": "送仓货件号",
    "Container_number": "柜号",
    "rfid_quantity": "RFID数量",
    "Undetected_quantity": "未检测数量",
    "Has_it_been_detected": "是否已检测",
    "List_of_inbound_inspection_tasks": "入库检测任务列表",
    "The_sublist_was_not_detected": "未检测子单",
    "The_sublist_has_been_inspected": "已检测子单",
    "undetected": "未检测",
    "detected": "已检测",
    "Supplement_the_past_outbound_orders": "补充过去出库单",
    "The_number_of_unchanged_product_labels": "未换产品标件数",
    "Upload_the_manual_label_change_file": "人工换标文件上传",
    "Label_change_type": "换标类型",
    "area": "区域",
    "upload_files": "上传文件",
    "Please_select_the_date_first": "请先选择日期",
    "Failed_to_obtain_the_date": "获取日期失败",
    "Failed_to_obtain_the_repository": "获取仓库失败",
    "store_code": "仓库编码",
    "Export_pdf": "导出pdf",
    "box_label": "箱标",
    "Upload_list": "上传列表",
    "old_sku": "原sku",
    "new_sku": "新sku",
    "Inventory_Location_Type": "库位类型",
    "The_file_name_cannot_contain_special_characters": "文件名不能存在特殊字符",
    "Export_the_information_of_goods_leaving_the_warehouse": "导出货物出库信息",
    "Exit_request_status": "出仓请求状态",
    "scan_status": "扫描状态",
    "warehouse_loading_status": "仓库装车状态",
    "Normal_warehouse_exit": "正常出仓",
    "The_platform_refuses_to_accept": "平台拒收",
    "Suspend_position_exit": "暂停出仓",
    "To_be_scanned": "待扫描",
    "Inventory_has_been_scanned_for_release": "已扫描出库",
    "Not_scanned_code": "未扫码",
    "Scanned_code": "已扫码",
    "Has_been_read": "是否已读",
    "unread": "未读",
    "read": "已读",
    "Set_to_read": "设置已读",
    "Are_you_sure_the_Settings_are_read": "确定设置已读吗",
    "occurrence_time": "发生时间",
    "Attention": "注意",
    "Please_do_not_input_the_file_extension": "请不要输入文件后缀",
    "Screenshot_of_the_export_page": "导出页面截图",
    "Copy_download_link": "复制下载链接",
    "Copy_successfully": "复制成功",
    "Copy_failed": "复制失败",
    "Goods_delivered_to_the_warehouse_multiple_times": "多次送仓货物",
    "The_date_cannot_be_empty": "日期不能为空",
    "Change_the_number_of_packages": "修改换标件数",
    "The_current_number_of_rebranded_items": "当前换标件数",
    "old_warehouse": "旧仓库",
    "current_warehouse": "当前仓库",
    "inbound_date": "入库日期",
    "Quantity_in_Stock": "入库数量",
    "warehouse_selection": "仓库选择",
    "Total_quantity_in_stock": "入库总数量",
    "Warehouse_entry_registration": "送仓登记",
    "New_Warehouse_entry_registration": "新建送仓登记",
    "reservation_number": "预约号",
    "Quantity_of_goods": "货件数量",
    "Please_fill_in_the_information_completely": "请完整填写信息",
    "Are_you_sure_you_want_to_cancel_the_reservation_registration": "确定要取消预约登记吗",
    "Cancel_reservation_registration": "取消预约登记",
    "Update_delivery_time": "更新送仓时间",
    "New_import": "新建导入",
    "update_status": "更新状态",
    "Quantity_of_label_changes": "换标数量",
    "Delivery_method": "送货方式",
    "Update_the_delivery_method": "更新送货方式",
    "Failed_to_obtain_the_repository_list": "获取仓库列表失败",
    "First_listing_time": "首次上架时间",
    "Is_the_suborder_empty": "子单是否为空",
    "empty": "空",
    "non_empty": "非空",
    "In_the_past_month": "近1个月",
    "go_back": "返回上级",
    "dashboard": "运营质量看板",
    "overseas_listing_exception": "海外上架异常",
    "total_unlisted_quantity": "未上架总件数",
    "warehousing_date": "入仓日期",
    "container_count": "柜子数",
    "quantity_to_be_listed": "应上架数",
    "unlisted_quantity": "未上架数",
    "overseas_outbound_exception": "海外出库异常",
    "total_rejected_quantity": "拒收总件数",
    "total_intercepted_quantity": "拦截总件数",
    "total_unscanned_quantity": "未扫码总件数",
    "outbound_date": "出库日期",
    "rejected_quantity": "拒收件数",
    "intercepted_quantity": "拦截件数",
    "unscanned_quantity": "未扫码件数",
    "box_damage_summary": "箱子破埙汇总",
    "total_damaged_quantity": "总破损件数",
    "total_repaired_quantity": "总修复件数",
    "damaged_quantity": "破埙件数",
    "repaired_quantity": "修复件数",
    "failed_to_get_overseas_listing_exception": "获取海外上架异常失败",
    "failed_to_get_overseas_outbound_exception": "获取海外出库异常失败",
    "failed_to_get_box_damage_summary": "获取箱子破埙汇总失败",
    "Change_the_inventory_to_unknown": "更改库存为未知",
    "Are_you_sure_you_want_to_change_the_inventory_to_unknown": "确定更改库存为未知吗",
    "Is_there_any_rejection": "是否有拒收",
  },
}